import { render, staticRenderFns } from "./RecepitItemsPerMonth.vue?vue&type=template&id=5677a254&scoped=true"
import script from "./RecepitItemsPerMonth.vue?vue&type=script&lang=js"
export * from "./RecepitItemsPerMonth.vue?vue&type=script&lang=js"
import style0 from "./RecepitItemsPerMonth.vue?vue&type=style&index=0&id=5677a254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677a254",
  null
  
)

export default component.exports